import api from '@/apis/tax/tAVATDeclarationAppendixAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('tAVATDeclarationAppendix', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ta_vat_declaration_appendix',
    field: {
      key: 'appendix_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
